import { simpleSet } from '@r/reducers/utils';

const setCalculationModeAdminSettingsPullsSearchText = simpleSet as
  redux.reducers.calculationMode.adminSettings.projectSettings.materials.pulls.searchText;

export const searchText = setCalculationModeAdminSettingsPullsSearchText(
  'SET_CALCULATION_MODE_ADMIN_SETTINGS_PULLS_SEARCH_TEXT',
  ''
);
